import { GroupDividerLayout } from '@/components/table/group-divider-layout.js';
import { StartDateGroupKey } from '@/lib/table-grouping-utils.js';
import { formatShortDateWithDayOfWeek } from '@airreading/common';

interface TeacherSessionDateDividerProps {
  groupKey: StartDateGroupKey;
  rowCount: number;
}

export function TeacherSessionDateDivider({ groupKey, rowCount }: TeacherSessionDateDividerProps) {
  return (
    <GroupDividerLayout rowCount={rowCount}>
      {formatShortDateWithDayOfWeek(groupKey.instant, groupKey.timeZone)}
    </GroupDividerLayout>
  );
}
